<template>
  <div class="section-container" v-if="displayList && displayList.length>0">
    <div v-for="(item, index) in displayList" :key="index">
      <div class="grey--text">{{ item.label }}</div>
      <div class="subheading pb-2">{{ item.value }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    displayList:Array
  },
}
</script>
<style scoped>
.section-container {
  display: flex;
  flex-wrap: wrap;
  align-self: center;
  flex: 1;
  gap: 5px;
  overflow-y: scroll;
  padding-right: 5px;
  padding-bottom:10px
}
</style>